import React from 'react';
import './Members.css';
import SEO from '../components/SEO';

const Members: React.FC = () => {
  // 5-star Google Reviews from actual members
  const googleReviews = [
    {
      name: 'Robert Bateman',
      business: 'No Time to Cook',
      rating: 5,
      review: 'Entrepreneurship is a challenging path and especially as a solo operator it can be especially so. The team at CC were extremely supportive and helpful as my business grew. The space is very clean, good area and walk in fridges. Equipment is excellent. I plan to be back very soon!',
      verified: true
    },
    {
      name: 'DIVYA TEJASWINI TALASANI',
      business: 'Magic Moringa',
      rating: 5,
      review: 'Starting a new business can be overwhelming, but Commissary Connect has truly been a game-changer for "Magic Moringa". From day one, their facilities have provided the perfect environment to grow and operate smoothly. I can\'t thank Ronica enough, she has been incredibly supportive, flexible, and understanding every step of the way. If you\'re thinking of starting a food business, I highly recommend Commissary Connect. The community, resources, and genuine care they offer make it one of the best places in Vancouver for food entrepreneurs. 💯💯💯',
      verified: true
    },
    {
      name: 'Natália Azin',
      business: 'Hey Brazilian Pizza',
      rating: 5,
      review: 'I\'m so excited to have Hey Brazilian Pizza start at Commissary Connect! As a new entrepreneur in the food scene, the support from everyone here has been incredible. The kitchen team works tirelessly, and the friendly atmosphere makes it feel like a family. You can really sense how much they want to see our business thrive! I\'m super grateful to be part of Commissary Connect and can\'t wait for all the amazing times ahead!',
      verified: true
    },
    {
      name: 'vanshika madaan',
      business: 'The Brownie Blondie Bakery',
      rating: 5,
      review: 'As a food entrepreneur and co-founder of The Brownie Blondie Bakery, I can\'t recommend this commissary kitchen enough. From a 10 hour package to 40hrs a week, the space has been a launchpad for our dreams. You get to put out your business right in the heart of downtown Vancouver. What truly sets this place apart is the community and the owners who are great entrepreneurs, always putting their heart out for your business to succeed.',
      verified: true
    },
    {
      name: 'Lucía Valenzuela',
      business: 'Food Entrepreneur',
      rating: 5,
      review: 'Commissary Connect is a well managed and clean commercial kitchen. The managing team assisted us in getting settled and meeting our needs throughout the time we operated from this space. Highly recommend to anyone starting a food business.',
      verified: true
    },
    {
      name: 'Miranda',
      business: 'Small Business Owner',
      rating: 5,
      review: 'We really cant say enough about how wonderful the people from commissary connect are. They have helped us out so much starting our small business and given us loads of advice! The facility is always so clean and well kept too :)',
      verified: true
    },
    {
      name: 'Maria Fernanda Guaraná',
      business: 'Food Entrepreneur',
      rating: 5,
      review: 'This kitchen is absolutely the BEST! 5 years ago it was the first kitchen we ever rented, we never had problems with anyone or anything whatsoever. Kitchen is clean, equipment is good and people are awesome. They really care for you and your business..they do workshops, pop-ups, meetings with farmers markets, promote you on their social media and even have a newsletter. I could rate it with soooo many stars but unfortunately I\'m only allowed 5 hahaha!',
      verified: true
    },
    {
      name: 'Andrew Yong',
      business: 'Tochi',
      rating: 5,
      review: 'We have been using this kitchen as our HQ for the past year and have had an amazing experience. Ronica is responsive and super super helpful. They took the time to customize a package that suited our needs and continue to give us support and guidance every step of the way. Can\'t recommend them enough!!!',
      verified: true
    },
    {
      name: 'Saanch Foods Corp',
      business: 'Saanch Foods',
      rating: 5,
      review: 'We rented a station at Commissary Connect (401 Industrial Ave, Vancouver) and couldn\'t have had a better experience! Ronica and Sarb have been absolutely amazing—always supportive, knowledgeable, and available with just one call. They even take the initiative to promote restaurants, organizing a whole photoshoot for us, which was such a thoughtful touch! Ronica and Sarb make you feel like family and help build a positive, supportive community.',
      verified: true
    },
    {
      name: 'OATME Superfood',
      business: 'OATME',
      rating: 5,
      review: 'We have a deep appreciation for Commissary Connect! The entire kitchen team is exceptionally supportive, the management is fantastic, and the staff is delightful to work with. They consistently exert significant effort to promote local businesses. We can\'t thank enough of what the entire team at Commissary Connect do for us!',
      verified: true
    },
    {
      name: 'Ali Cant',
      business: 'Food Business Owner',
      rating: 5,
      review: 'I started my food business here in 2019, and could not be happier with my decision. The space meets all our needs, we are surrounded daily by inspiring entrepreneurs, and the location is perfect. The rates are competitive, we had plenty of support to get us off the ground, and management is always actively looking for ways to help us grow/succeed.',
      verified: true
    },
    {
      name: 'Agnes Wong',
      business: 'Buttercrumbs',
      rating: 5,
      review: 'Just joined commissary connect and Jennifer has been amazing with getting me on-boarded with the facility. Not to mention, they are very responsive and are quick with getting any issues resolved if equipment needs to be fixed. Great community!',
      verified: true
    }
  ];


  return (
    <div className="members-page">
      {/* 1,423 impr but pos 34.6 — page 4, effectively invisible */}
      <SEO
        title="Kitchen Members & Food Brands | Commissary Connect"
        description="The food businesses building from our kitchens — bakeries, caterers, meal prep and CPG brands. See who works here and what they make."
        keywords="commissary connect members, vancouver food brands, shared kitchen community"
      />
      <div className="container">
        <h1>Our Members</h1>
        
        <div className="member-intro">
          <p className="intro-text">
            We're proud to be the trusted home for <strong>100+ thriving food businesses</strong> across the Lower Mainland. 
            Our diverse community includes ghost kitchens, meal prep innovators, boutique caterers, 
            CPG brands, farmers market artisans, chocolatiers, craft bakeries, food trucks, and culinary entrepreneurs 
            of every kind. From your first farmer's market to national retail distribution, we provide the 
            professional kitchen space and supportive ecosystem where food dreams become successful businesses.
          </p>
        </div>
        
        {/* Google Reviews Section */}
        <div className="google-reviews-section">
          <p className="reviews-subtitle">See what our members are saying about Commissary Connect</p>
          
          <div className="reviews-grid">
            {googleReviews.map((review, index) => (
              <div key={index} className="review-card">
                <div className="review-header">
                  <div className="reviewer-info">
                    <h3>{review.name}</h3>
                    <p className="business-name">{review.business}</p>
                  </div>
                  <div className="review-meta">
                    <div className="stars">
                      {'⭐'.repeat(review.rating)}
                    </div>
                  </div>
                </div>
                <p className="review-text">"{review.review}"</p>
                {review.verified && (
                  <div className="verified-badge">
                    ✓ Verified Google Review
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>

        
        <div className="member-stats">
          <div className="stat">
            <h2>100+</h2>
            <p>Active Food Businesses</p>
          </div>
          <div className="stat">
            <h2>12+</h2>
            <p>Years of Service</p>
          </div>
          <div className="stat">
            <h2>8</h2>
            <p>Kitchen Locations</p>
          </div>
          <div className="stat">
            <h2>50K+</h2>
            <p>Sq Ft Kitchen Space</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Members;